export default {
  meta: {
    title: '查看收藏区域',
    url: '/recommend/modal', // 埋点用，记录所属模块
    // eventId: '93fc1755-8e57-4ce9-978a-3fe48cc43aca'
  },
};
